module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('nav', {
    staticClass: "navbar navbar-default app-head"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), (_vm.isProd) ? _c('span', {
    staticStyle: {
      "color": "yellow",
      "line-height": "55px",
      "font-size": "20px"
    }
  }, [_vm._v("已连接正式服务器！！！")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm._f("parseRoleType")(_vm.roleId)) + "：" + _vm._s(_vm.roleName) + " - ( " + _vm._s(_vm.userId) + " )")]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('span', {
    staticClass: "_btn",
    on: {
      "click": _vm.toSupervisor
    }
  }, [_vm._v("前往监管系统")]), _vm._v(" "), (_vm.mulRole == true) ? _c('span', {
    staticClass: "_btn",
    on: {
      "click": _vm.switchRole
    }
  }, [_vm._v("切换用户")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "_btn out",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("安全退出")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/index"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/inner-logo.png"),
      "alt": "首页"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f78d989","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/app_head.vue
// module id = 595
// module chunks = 143